import { StateNode } from '@ansys-internal/awf-angular/store';
import { AWCTreeItem } from '@ansys-internal/awc-angular/tree';

export class ComponentsState implements StateNode<AWCTreeItem[]> {
  key: string = 'components';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => AWCTreeItem[] = () => [];
  onChange: (state: any) => void = (state) => {};
}
